import { useGetStaffQuery } from "../staffSlice";
import useOrganisationId from "../../organisations/hooks/useOrganisationId";
import useHasAccess from "../../../hooks/useHasAccess";
import useRefresher from "../../../hooks/useRefresher";

const useStaff = () => {
  const organisationId = useOrganisationId();
  const hasAccess = useHasAccess({
    apiCall: "organisations.id.users.GET",
    organisation: organisationId,
  });

  const staff = useGetStaffQuery(
    { id: organisationId },
    { skip: organisationId == null || !hasAccess }
  );
  useRefresher(staff);

  return { ...staff, hasAccess };
};

export default useStaff;
